import { authManager } from '../auth-manager.js';

export function renderLandingView(container, syncManager) {
  const isAuthenticated = authManager.isAuthenticated();

  container.innerHTML = `
    <div class="landing-page-root">
      <!-- Navbar -->
      <header class="landing-navbar">
        <div class="landing-nav-container">
          <a href="#landing" class="landing-brand">
            <img src="/favicon.svg" alt="NF Tracker Logo" class="landing-brand-logo" />
            <span class="landing-brand-name">NF Tracker</span>
            <span class="landing-brand-badge">Beta</span>
          </a>
          <a href="${isAuthenticated ? '#notas' : '#login'}" class="landing-btn-primary">
            ${isAuthenticated ? 'Ir para o App' : 'Entrar'}
          </a>
        </div>
      </header>

      <!-- Hero Section -->
      <section class="landing-hero-section">
        <div class="landing-hero-container">
          <div class="landing-pill-tag">
            <span class="material-symbols-outlined">receipt</span>
            <span>Controle Financeiro com NFC-e</span>
          </div>

          <h1 class="landing-headline">
            Organize seus gastos e compras em família com inteligência.
          </h1>

          <p class="landing-subheadline">
            Digitalize notas fiscais via QR Code, compartilhe listas de compras e acompanhe o orçamento familiar com dados claros e objetivos.
          </p>

          <div class="landing-cta-group">
            ${isAuthenticated ? `
              <a href="#notas" class="landing-btn-cta-primary">
                Ir para o App
                <span class="material-symbols-outlined" style="font-size: 18px;">arrow_forward</span>
              </a>
              <a href="#manual" class="landing-btn-cta-secondary">
                <span class="material-symbols-outlined" style="font-size: 18px; color: #2563EB;">menu_book</span>
                Ver Como Usar
              </a>
            ` : `
              <a href="#login" class="landing-btn-cta-primary">
                Ir para o App
                <span class="material-symbols-outlined" style="font-size: 18px;">arrow_forward</span>
              </a>
              <a href="#manual" class="landing-btn-cta-secondary">
                <span class="material-symbols-outlined" style="font-size: 18px; color: #2563EB;">menu_book</span>
                Como Usar (Manual)
              </a>
              <a href="#recursos" id="btn-learn-more" class="landing-btn-cta-secondary" style="border: none; background: transparent;">
                Ver Recursos
              </a>
            `}
          </div>

          <!-- Quick Highlight Strip -->
          <div class="landing-highlights-strip">
            <div class="landing-highlight-item">
              <span class="material-symbols-outlined">qr_code_scanner</span>
              <div>
                <strong>Leitura por QR Code</strong>
                <p>Extração automática de itens, quantidades e valores.</p>
              </div>
            </div>
            <div class="landing-highlight-item">
              <span class="material-symbols-outlined">group</span>
              <div>
                <strong>Espaço Familiar</strong>
                <p>Listas e compras compartilhadas em tempo real.</p>
              </div>
            </div>
            <div class="landing-highlight-item">
              <span class="material-symbols-outlined">offline_bolt</span>
              <div>
                <strong>Suporte Offline</strong>
                <p>Funciona no celular mesmo sem sinal de internet.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Features Section -->
      <section class="landing-features-section" id="recursos">
        <div class="landing-section-heading">
          <h2>Recursos Principais</h2>
          <p>Ferramentas diretas para simplificar sua rotina.</p>
        </div>

        <div class="landing-cards-grid">
          <!-- Card 1 -->
          <div class="landing-card">
            <div class="landing-card-icon">
              <span class="material-symbols-outlined" style="font-size: 24px;">receipt_long</span>
            </div>
            <h3>Digitalização de NFC-e</h3>
            <p>Aponte a câmera para o QR Code da nota fiscal e obtenha em instantes a lista completa de produtos, preços unitários, quantidades e totais.</p>
          </div>

          <!-- Card 2 -->
          <div class="landing-card">
            <div class="landing-card-icon">
              <span class="material-symbols-outlined" style="font-size: 24px;">checklist</span>
            </div>
            <h3>Listas de Compras em Família</h3>
            <p>Crie listas colaborativas com estimativa de custo, marcação de itens em tempo real e chat integrado para alinhar as compras do mês.</p>
          </div>

          <!-- Card 3 -->
          <div class="landing-card">
            <div class="landing-card-icon">
              <span class="material-symbols-outlined" style="font-size: 24px;">monitoring</span>
            </div>
            <h3>Histórico e Análise de Preços</h3>
            <p>Acompanhe a evolução do total gasto, ticket médio por compra e veja o histórico de preços pagos por produto nos mercados da sua região.</p>
          </div>

          <!-- Card 4 -->
          <div class="landing-card">
            <div class="landing-card-icon">
              <span class="material-symbols-outlined" style="font-size: 24px;">cell_merge</span>
            </div>
            <h3>Central de Notificações</h3>
            <p>Receba alertas em tempo real quando um familiar marcar um item como comprado, adicionar um produto ou enviar mensagens no chat.</p>
          </div>
        </div>
      </section>

      <!-- Guide Promo Section -->
      <section style="padding: 2.5rem 1.25rem; max-width: 960px; margin: 0 auto;">
        <div style="background: linear-gradient(135deg, rgba(37, 99, 235, 0.08) 0%, rgba(16, 185, 129, 0.06) 100%); border: 1px solid rgba(37, 99, 235, 0.2); border-radius: 1.25rem; padding: 1.75rem 1.5rem; display: flex; align-items: center; justify-content: space-between; gap: 1.25rem; flex-wrap: wrap;">
          <div style="flex: 1; min-width: 260px;">
            <div style="display: inline-flex; align-items: center; gap: 0.35rem; font-size: 0.75rem; font-weight: 800; color: #2563EB; background: rgba(37, 99, 235, 0.1); padding: 0.2rem 0.6rem; border-radius: var(--radius-pill); margin-bottom: 0.5rem;">
              <span class="material-symbols-outlined" style="font-size: 16px;">school</span>
              <span>Passo a Passo Simples</span>
            </div>
            <h3 style="font-size: clamp(1.2rem, 3vw, 1.5rem); font-weight: 900; color: var(--text-main, #0F172A); margin: 0 0 0.4rem 0;">
              Novo no aplicativo? Veja o Guia Fácil! 📖
            </h3>
            <p style="font-size: 0.88rem; color: var(--text-muted, #475569); line-height: 1.5; margin: 0;">
              Descubra em 2 minutos como criar sua lista, ler os cupons fiscais no caixa e comparar o que foi planejado com o valor real pago.
            </p>
          </div>
          <a href="#manual" class="landing-btn-cta-primary" style="padding: 0.75rem 1.5rem; font-size: 0.92rem; flex-shrink: 0; text-decoration: none;">
            <span class="material-symbols-outlined" style="font-size: 20px;">menu_book</span>
            <span>Ver Manual Completo</span>
          </a>
        </div>
      </section>

      <!-- Footer -->
      <footer class="landing-footer">
        <div class="landing-footer-inner">
          <div class="landing-footer-brand">
            <img src="/favicon.svg" alt="NF Tracker" />
            <span>NF Tracker</span>
          </div>
          <div class="landing-footer-right" style="display: flex; align-items: center; gap: 1rem; flex-wrap: wrap;">
            <a href="#manual" style="text-decoration: none; color: var(--text-muted, #64748B); font-size: 0.82rem; font-weight: 700; display: inline-flex; align-items: center; gap: 0.25rem;">
              <span class="material-symbols-outlined" style="font-size: 16px; color: #2563EB;">menu_book</span>
              Manual do App
            </a>
            <p class="landing-footer-copy">
              &copy; ${new Date().getFullYear()} NF Tracker • Controle Pessoal e Familiar de Gastos
            </p>
            <a href="/next/" class="landing-footer-next-link" title="Acessar versão experimental Next">
              <span class="material-symbols-outlined" style="font-size: 13px;">science</span>
              Versão Next
            </a>
          </div>
        </div>
      </footer>
    </div>
  `;

  // Scroll smoothly to features
  container.querySelector('#btn-learn-more')?.addEventListener('click', (e) => {
    e.preventDefault();
    container.querySelector('#recursos')?.scrollIntoView({ behavior: 'smooth' });
  });

  // Footer Next Link Channel Persistence
  container.querySelector('.landing-footer-next-link')?.addEventListener('click', () => {
    try {
      localStorage.setItem('nfce_app_channel', 'next');
    } catch (e) {}
  });
}
